import React from 'react';
import type { ProductStat } from '../../types/product';
type ResultsBandProps = {
  heading: string;
  items: ProductStat[];
  illustrative?: boolean;
};
export function ResultsBand({
  heading,
  items,
  illustrative = true
}: ResultsBandProps) {
  return <section className="w-full bg-white py-20" aria-labelledby="results-heading" data-id="element-1557" data-mp="2iilkajuex48t">
      <div className="mx-auto max-w-shell px-6" data-id="element-1558" data-mp="2nf3mbbycyohg">
        <div className="flex flex-wrap items-center gap-3" data-id="element-1559" data-mp="1qpm7a6dhjq33">
          <h2 id="results-heading" className="display text-[30px] font-semibold text-ink sm:text-[40px]" data-id="element-1560" data-mp="1qr5qo5ufuh93">
            {heading}
          </h2>
          {illustrative && <span className="rounded-full border border-dashed border-ink/25 px-2.5 py-1 text-[12px] font-medium text-ink-muted" data-id="element-1561" data-mp="1zp99uvhyb1xq">
              Illustrative
            </span>}
        </div>
        <dl className="mt-10 grid grid-cols-1 gap-8 sm:grid-cols-3" data-id="element-1562" data-mp="3b4efa79gvel1">
          {items.map(stat => <div key={stat.label} className="border-t border-canvas-line pt-6" data-id="element-1563" data-mp="3g2pnkdk45h15">
              <dt className="sr-only" data-id="element-1564" data-mp="q18hop8e5l7f">{stat.label}</dt>
              <dd data-id="element-1565" data-mp="pzxbyjvdy3do">
                <span className="display block text-[48px] font-semibold text-brand sm:text-[60px]" data-id="element-1566" data-mp="m0y3wqecxqi0">{stat.value}</span>
                <span className="mt-2 block max-w-[280px] text-[15px] leading-[1.5] text-ink-muted" data-id="element-1567" data-mp="h0selgvk8g33">{stat.label}</span>
              </dd>
            </div>)}
        </dl>
      </div>
    </section>;
}